const en_master_unit = {
    add: "add unit",
    code: "unit code",
    name: "unit name",

    error: {
        code: "Unit code cannot be empty.",
        name: "Unit name cannot be empty.",
        create: "Failed to create unit.",
        delete: "Failed to delete unit.",
        edit: "Failed to update unit.",
    },

    success: {
        create: "Unit created successfully.",
        delete: "Unit deleted successfully.",
        edit: "Unit updated successfully.",
    }

}

export default en_master_unit;